<template>
    <main id="js-page-content" class="companies-v2" role="main">
        <portal to="ariane">
            <div class="tbv2-page-title">{{ $t('admin.companies.title') }}</div>
        </portal>

        <header class="companies-hero">
            <h1 class="companies-hero-title">{{ $t('admin.companies.title') }}</h1>
            <p class="companies-hero-sub">{{ subtitleLabel }}</p>
        </header>

        <section class="companies-card">
            <TabCompanies v-if="companies" />
        </section>
    </main>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import TabCompanies from '@/components/Model/Admin/TabCompanies'
import { mapActions, mapState } from 'vuex'

export default {
    name: 'AdminCompanies',
    components: { TabCompanies },
    computed: {
        ...mapState('admin', {
            companies: (state) => state.companies
        }),
        subtitleLabel() {
            const n = this.companies && this.companies.total ? this.companies.total : 0
            if (n === 0) return this.$t('admin.companies.count_zero')
            const formatted = new Intl.NumberFormat(this.$i18n.locale).format(n)
            const key = n === 1 ? 'admin.companies.count_one' : 'admin.companies.count_other'
            return this.$t(key, { count: formatted })
        }
    },
    created() {
        this.getCompanies()
        this.getCompaniesFilters()
    },
    methods: {
        ...mapActions('admin', ['getCompanies', 'getCompaniesFilters'])
    }
}
</script>

<style scoped>
.companies-v2 {
    width: 100%;
    padding: 24px 32px 48px;
    font-family: var(--v2-font-sans);
    color: var(--v2-text-2);
}

.tbv2-page-title {
    font-size: 0.95rem;
    font-weight: var(--v2-font-weight-semibold);
    color: var(--v2-text-1);
    letter-spacing: -0.005em;
}

.companies-hero {
    margin-bottom: var(--v2-space-5);
}

.companies-hero-title {
    margin: 0 0 6px;
    font-size: 1.75rem;
    font-weight: var(--v2-font-weight-bold);
    color: var(--v2-text-1);
    letter-spacing: -0.02em;
    line-height: 1.15;
}

.companies-hero-sub {
    margin: 0;
    font-size: var(--v2-text-sm-size);
    color: var(--v2-text-3);
    line-height: 1.5;
}

.companies-card {
    background: var(--v2-surface-0);
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-lg);
    overflow: hidden;
}

@media (max-width: 900px) {
    .companies-v2 {
        padding: 16px 18px 32px;
    }

    .companies-hero-title {
        font-size: 1.375rem;
    }
}
</style>
